import { render, staticRenderFns } from "./OracleZjjhbModal__Style#Drawer.vue?vue&type=template&id=24276496&scoped=true&"
import script from "./OracleZjjhbModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./OracleZjjhbModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./OracleZjjhbModal__Style#Drawer.vue?vue&type=style&index=0&id=24276496&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24276496",
  null
  
)

export default component.exports